import { render } from "./SignOut.vue?vue&type=template&id=c2b1c0ee"
import script from "./SignOut.vue?vue&type=script&lang=js"
export * from "./SignOut.vue?vue&type=script&lang=js"

import exportComponent from "C:\\agent\\_work\\55\\s\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__